import { render, staticRenderFns } from "./NfCard.vue?vue&type=template&id=1b2e5dbc&scoped=true&"
import script from "./NfCard.vue?vue&type=script&lang=js&"
export * from "./NfCard.vue?vue&type=script&lang=js&"
import style0 from "./NfCard.vue?vue&type=style&index=0&id=1b2e5dbc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2e5dbc",
  null
  
)

export default component.exports